import { PropsWithChildren } from 'react';

type AccordionProps = PropsWithChildren<{
    title?: string;
}>

export const Accordion = ({ title, children }: AccordionProps) => {
    return (
        <>
            {title && (
                <h2 className={'text-xl font-semibold mb-4'}>
                    {title}
                </h2>
            )}

            <div>
                {children}
            </div>
        </>
    );
};
